import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ConstantService {

    API_URL: string = environment.API_URL;
    LOGIN: string = 'auth/userLogin';
    LOGOUT: string = 'logout';
    FORGETPASSWORD = 'auth/userForgetPassword';
    RESETPASSWORD = 'auth/userResetPassword';
    VALIDATESESSION = 'auth/validateSession';
    CHECKSESSION = 'auth/checkSession';

    PARTNERS = 'partners';
    CUSTOMERS = 'customers';
    LOANS = 'loans';
    BRANCHES = 'branches';
    LOANAPPLICANT = 'loanApplication';
    APPLICATION = 'application';
    SETTINGS = 'settings';
    PINCODE = 'settings/locations';
    USERS = 'users';
    NOTIFICATION = 'notifications';
    RBACPERMISSION = 'rbacpermissions';
    LEAD = 'lead';
    LOG = 'logs';
    REPORTSCHEMAS = 'reportschema';
  

  constructor() { }

  getUrl(path: string , params: Array<any> = []){
      return !params.length ? [this.API_URL,path].join('') : [[this.API_URL,path].join(''),params.join('/')].join('/');
  }

  getUrlByQuery(path: string , query:Array<Object>){
      let url =  [this.API_URL,path].join('');
      let queryString = query.map((o:any)=>{
            return `${o.name}=${o.value}`;
      }).join('&');
      return [url,queryString].join('?');
  }
}
